export const FI_STORAGE_KEY = "client_fi";
